module.exports = __webpack_public_path__ + "static/media/shopping-bag.a3155760.svg";